import request from '@/utils/request'
import gateway_request from '@/utils/gateway_req'

const auth = {
    /**
     * 根据用户openid获取custId
     * @param {Object} data 
     * @param {string} data.openid
     */
    getCustId(params) {
        return request({
            url: '?s=Customer.Web.GetCustId',
            method: 'GET',
            params: params
        })
    },
     /**
     * App其他在线客服入口更新用户信息
     */
    updateAppUserInfo(params) {
        return request({
            url: '?s=Customer.Web.updateCarInfo',
            method: 'POST',
            data: params
        })
    },
    async getWechatUserInfo(params) {
		return request({
			url: '?s=Customer.Web.getWechatUserInfo',
			method: 'post',
			data: params,
		})
	},

    /**
     * 更新个人信息
     * @param {*} data 
     */
    updateUserInfo(data) {
        return request({
            url: '?s=Customer.Web.UpdateUserInfo',
            method: 'POST',
            data: data
        })
    },

	/**
	 * App其他在线客服入口更新用户信息
	 */
	updateAppUserInfo(params) {
		return request({
			url: '?s=Customer.Web.updateCarInfo',
			method: 'POST',
			data: params
		})
	},

	/**
	 * 获取userSig密钥
	 * @param {Object} data
	 * @param {string} data.identifier
	 */
	getTIMGenSIg(params) {
		return request({
			url: '?s=App.Sign.GenSig',
			method: 'GET',
			params: params,
		})
	},

    /**
     * 获取满意度评价信息
     * @param {Object} data
     * @param {string} data.identifier
     */
    getSatisfactionConfig(params) {
        return gateway_request({
            url: '?s=Customer.UserSession.getSatisfaction',
            method: 'GET',
            params: params
        })
    },

    /**
     * 满意度评价
     * @param {Object} data
     * @param {string} data.identifier
     */
    saveSatisfactionGrade(params) {
        return gateway_request({
            url: '?s=Customer.UserSession.saveSatisfaction',
            method: 'POST',
            data: params
        })
    },

    /**
     * 查询用户是否同意机器人回复消息
     */
    getAgreeRobotRecord(params) {
        return request({
            url: '?s=Customer.Common.getAgreeRobotRecord',
            method: 'POST',
            params
        })
    },

    /**
     * 添加用户同意机器人回复消息
     */

    addAgreeRobotRecord(params) {
        return request({
            url: '?s=Customer.Common.addAgreeRobotRecord',
            method: 'POST',
            params
        })
    },
}

export default auth